import type { ComponentConfig } from "@puckeditor/core"
import { FormBody } from "./form-body"
import { SectionBase } from "../lib/section"

export type FormField = { label: string; type: "text" | "email" | "tel" | "textarea" | "consent"; required: "yes" | "no" }

export type FormProps = SectionBase & {
  eyebrow: string
  title: string
  subtitle: string
  submitLabel: string
  fields: FormField[]
  /** Where the storefront posts the form, e.g. /api/forms/contact */
  action: string
  successMessage: string
}

export type { FormBodyProps } from "./form-body"
export { FormBody } from "./form-body"

export const Form: ComponentConfig<FormProps> = {
  fields: {
    eyebrow: { type: "text", label: "Eyebrow", contentEditable: true },
    title: { type: "textarea", contentEditable: true },
    subtitle: { type: "textarea", contentEditable: true },
    submitLabel: { type: "text", label: "Submit label", contentEditable: true },
    action: { type: "text", label: "Endpoint path", contentEditable: true },
    successMessage: { type: "text", label: "Success message", contentEditable: true },
    fields: {
      type: "array",
      arrayFields: {
        label: { type: "text", label: "Label", contentEditable: true },
        type: {
          type: "select",
          options: [
            { label: "Text", value: "text" },
            { label: "Email", value: "email" },
            { label: "Phone", value: "tel" },
            { label: "Textarea", value: "textarea" },
            { label: "Consent checkbox", value: "consent" },
          ],
        },
        required: {
          type: "select",
          options: [
            { label: "Required", value: "yes" },
            { label: "Optional", value: "no" },
          ],
        },
      },
      defaultItemProps: { label: "Your message", type: "text", required: "no" } as FormField,
      getItemSummary: (item: FormField) => item?.label || "Field",
    },
    background: {
      type: "radio",
      options: [
        { value: "none", label: "Transparent" },
        { value: "muted", label: "Muted" },
        { value: "accent", label: "Dark" },
      ],
    },
    paddingY: {
      type: "radio",
      options: [
        { value: "none", label: "None" },
        { value: "sm", label: "Small" },
        { value: "md", label: "Medium" },
        { value: "lg", label: "Large" },
      ],
    },
  },

  defaultProps: {
    eyebrow: "",
    title: "Contact us",
    subtitle: "We will get back to you within one business day.",
    submitLabel: "Send",
    action: "/api/forms/contact",
    successMessage: "Thank you! Your message has been sent.",
    fields: [{ label: "Email", type: "email", required: "yes" }],
    background: "none",
    paddingY: "lg",
  },

  // FormBody is a client component and Form has no drop zones, so the
  // puck prop (renderDropZone and other functions injected by Puck's RSC
  // Render) must not cross the client boundary: drop it here.
  render: ({ puck: _puck, ...props }) => <FormBody {...props} />,
}
